<template>
    <div>
        <div id="main-wrapper">
            <AsideBar/>

            <div class="page-wrapper">
                <HeaderBar/>
                <router-view />
            </div>

        </div>
    </div>
</template>

<script>

import AsideBar from '@/components/AsideBar.vue'
import HeaderBar from '@/components/HeaderBar.vue'

export default {
  name: 'HomeView',
  components: {
    AsideBar,
    HeaderBar
  }
}
</script>